import React from 'react';
import { Box, TextField, Typography, InputAdornment, IconButton } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import { ReactComponent as SearchIcon } from '../../../src/assets/SVG/Search-Icon.svg';
import { useTranslation } from 'react-i18next';
import { ReactComponent as AddIcon } from '../../../src/assets/SVG/addPlusButton.svg';
import { getButtonStates } from '../../utils/permissionService';

interface Props {
  search: string;
  onSearchChange: (val: string) => void;
  onCreate?: () => void;
}

const ClinicListHeader: React.FC<Props> = ({ search, onSearchChange, onCreate }) => {
  const { t: tClinic } = useTranslation('clinic_config');
  const { canEdit, canAdd } = getButtonStates('Settings', 'Configuration', 'Clinic');


  return (
    <Grid2 container justifyContent="space-between" alignItems="center" mb={2}>
      <Typography
        variant="h6"
        sx={{
          fontFamily: 'Montserrat',
          fontWeight: 700,
          fontSize: '20px',
          lineHeight: '145%',
          letterSpacing: 0
        }}
      >
        {tClinic('ClinicList_Page.Text_ClinicList') || 'Clinic List'}
      </Typography>
      <Box display="flex" alignItems="center">
        <TextField
          size="small"
          placeholder={tClinic('ClinicList_Page.Text_SearchByClinicName') || 'Search Clinic'}
          variant="outlined"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" sx={{ pl: 1 }}>
                <Box component="span" sx={{ display: 'flex', alignItems: 'center', height: 24 }}>
                  <SearchIcon style={{ height: 20, width: 20 }} />
                </Box>
              </InputAdornment>
            ),
          }}
        />
        {(canAdd || canEdit)  && (
          <IconButton
            color="primary"
            sx={{ ml: 2 }}
            onClick={onCreate}
          >
            <AddIcon style={{ height: 40, width: 40 }} />
          </IconButton>
        )}
      </Box>
    </Grid2>
  );
};

export default ClinicListHeader;
